/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateMachineFromReviewRequest model module.
 * @module model/CreateMachineFromReviewRequest
 * @version 0.0.1
 */
class CreateMachineFromReviewRequest {
    /**
     * Constructs a new <code>CreateMachineFromReviewRequest</code>.
     * @alias module:model/CreateMachineFromReviewRequest
     * @param serial {String} 
     */
    constructor(serial) { 
        
        CreateMachineFromReviewRequest.initialize(this, serial);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, serial) { 
        obj['serial'] = serial;
    }

    /**
     * Constructs a <code>CreateMachineFromReviewRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateMachineFromReviewRequest} obj Optional instance to populate.
     * @return {module:model/CreateMachineFromReviewRequest} The populated <code>CreateMachineFromReviewRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateMachineFromReviewRequest();

            if (data.hasOwnProperty('serial')) {
                obj['serial'] = ApiClient.convertToType(data['serial'], 'String');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('owner')) {
                obj['owner'] = ApiClient.convertToType(data['owner'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CreateMachineFromReviewRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateMachineFromReviewRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CreateMachineFromReviewRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['serial'] && !(typeof data['serial'] === 'string' || data['serial'] instanceof String)) {
            throw new Error("Expected the field `serial` to be a primitive type in the JSON string but got " + data['serial']);
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['owner'] && !(typeof data['owner'] === 'string' || data['owner'] instanceof String)) {
            throw new Error("Expected the field `owner` to be a primitive type in the JSON string but got " + data['owner']);
        }

        return true;
    }


}

CreateMachineFromReviewRequest.RequiredProperties = ["serial"];

/**
 * @member {String} serial
 */
CreateMachineFromReviewRequest.prototype['serial'] = undefined;

/**
 * @member {String} type
 */
CreateMachineFromReviewRequest.prototype['type'] = undefined;

/**
 * @member {String} owner
 */
CreateMachineFromReviewRequest.prototype['owner'] = undefined;






export default CreateMachineFromReviewRequest;

